import styled from 'styled-components';

import {ReactNode} from 'react';

import i18n from '@dms/i18n';
import {Button, noop} from '@dms/teas';

export type ActionType = {
  label?: ReactNode;
  icon?: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
};

export type BulkActionsProps = {
  itemsSelected: number;
  actions?: ActionType[];
  onCancel?: () => void;
  tableName?: string;
};

export const BulkActionsBar = ({itemsSelected, actions, onCancel, tableName}: BulkActionsProps) => (
  <BulkWrapper>
    <div>
      {itemsSelected}&nbsp;
      {i18n.t('general.labels.itemsSelected')}
    </div>
    <BulkButtonsWrapper>
      {actions?.map(({label, icon, onClick, disabled}) => (
        <BulkButton
          key={`${tableName}-${label}`}
          compact
          primary
          icon={icon}
          onClick={() => (onClick !== undefined ? onClick() : noop)}
          disabled={disabled}
          data-testid={`${tableName}-${label}`}
        >
          {label}
        </BulkButton>
      ))}
      <BulkButtonsDivider />
      <BulkButton
        compact
        primary
        onClick={() => (onCancel !== undefined ? onCancel() : noop)}
        data-testid={`${tableName}-cancel`}
      >
        {i18n.t('general.actions.cancel')}
      </BulkButton>
    </BulkButtonsWrapper>
  </BulkWrapper>
);

const BulkWrapper = styled.div`
  font-family: ${({theme}) => theme.fonts.body};
  font-size: ${({theme}) => theme.fontSizes.text.xSmall};
  width: 100%;
  background-color: ${({theme}) => theme.colors.palettes.blue[60][100]};
  color: ${({theme}) => theme.colors.palettes.white[10][100]};
  display: flex;
  justify-content: space-between;
  padding: 6px ${({theme}) => theme.getSize(4)};
  align-items: center;
`;

const BulkButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const BulkButton = styled(Button)`
  margin: 0 6px;
`;

const BulkButtonsDivider = styled.div`
  border-left: 1px solid ${({theme}) => theme.colors.palettes.white[10][100]};
  height: ${({theme}) => theme.fontSizes.text.base};
  margin: 0;
  padding: 0;
`;
